import { http } from './common';

const getSummary = async () => {
    return http.get('/api/v1/patterns/summary');
};

const getPatterns = async (params?: any) => {
    return http.get('/api/v1/patterns', params);
};

const getPatternClaims = async (patternId: string | number) => {
    return http.get(`/api/v1/patterns/${patternId}/claims`);
};

export {
    getSummary,
    getPatterns,
    getPatternClaims
};
